module.exports = __webpack_public_path__ + "img/ZJ5335.e73cd185.png";